import { userService } from "../services";
import config from "../config/config";

export const NitMasterAction = {
  fetchNitList,
  createNit,
  updateNit,
  deleteNit,
  getNitById,
  getNitById2,
  importNITs,
  fetchNitReportList,
  fetchNitListByVendorMine,
  getAllContractTypes,
  getAllWorkTypes,
  createContractType,
  createWorkType,
  fetchNitLeadReport,
  fetchNitVehicleLeadReport,
  fetchNitListForDropdown,
};
async function fetchNitLeadReport(payload, showSnackbar) {
  try {
    let apiEndpoint = `${config.baseUrl}${config.apiName.fetchNitLeadReport}?page=NIT_LEAD_REPORT&pageNo=${payload.pageNo}&pageSize=${payload.pageSize}`;

    let response = await userService.post(apiEndpoint, payload);

    if (response && response.status === 200) {
      return response.data;
    } else {
      console.log(response);
      if (showSnackbar) {
        showSnackbar(
          response?.data?.message || "Error fetching NIT Lead Report",
          "error",
        );
      }
      return null;
    }
  } catch (error) {
    console.log("error in fetchNitLeadReport:", error);
    if (showSnackbar) {
      showSnackbar(
        error?.response?.data?.message || "Error fetching NIT Lead Report",
        "error",
      );
    }
    return null;
  }
}

async function fetchNitVehicleLeadReport(payload, showSnackbar) {
  try {
    let apiEndpoint = `${config.baseUrl}${config.apiName.fetchNitLeadReport}?page=NIT_VEHICLE_LEAD_REPORT&pageNo=${payload.pageNo}&pageSize=${payload.pageSize}`;

    let response = await userService.post(apiEndpoint, payload);

    if (response && response.status === 200) {
      return response.data;
    } else {
      console.log(response);
      if (showSnackbar) {
        showSnackbar(
          response?.data?.message || "Error fetching NIT Vehicle Lead Report",
          "error",
        );
      }
      return null;
    }
  } catch (error) {
    console.log("error in fetchNitVehicleLeadReport:", error);
    if (showSnackbar) {
      showSnackbar(
        error?.response?.data?.message ||
          "Error fetching NIT Vehicle Lead Report",
        "error",
      );
    }
    return null;
  }
}
async function fetchNitListForDropdown(showSnackbar) {
  try {
    let apiEndpoint = `${config.baseUrl}${config.apiName.fetchNitListForDropdown}`;

    let response = await userService.get(apiEndpoint);

    if (response && response.status === 200) {
      return response.data;
    } else {
      console.log(response);
      showSnackbar(response.data.message, "error");

      return null;
    }
  } catch (error) {
    console.log("error", error);
    return null;
  }
}

async function fetchNitList(payload, showSnackbar) {
  try {
    let apiEndpoint = `${config.baseUrl}${config.apiName.nitList}`;

    let response = await userService.post(apiEndpoint, payload);

    if (response && response.status === 200) {
      return response.data;
    } else {
      console.log(response);
      showSnackbar(response.data.message, "error");

      return null;
    }
  } catch (error) {
    console.log("error", error);
    return null;
  }
}
async function fetchNitListByVendorMine(payload, showSnackbar) {
  try {
    let apiEndpoint = `${config.baseUrl}${config.apiName.fetchNitListByVendorMine}?mineId=${payload?.mineId}&vendorId=${payload?.vendorId}&typeId=${payload?.typeId}`;

    let response = await userService.get(apiEndpoint);

    if ((response && response.status === 200) || response.status === 204) {
      return response.data;
    } else {
      console.log(response);
      showSnackbar(response.data.message, "error");

      return null;
    }
  } catch (error) {
    console.log("error", error);
    return null;
  }
}
async function fetchNitReportList(payload, showSnackbar) {
  try {
    let apiEndpoint = `${config.baseUrl}${config.apiName.fetchNitReportList}`;

    let response = await userService.post(apiEndpoint, payload);

    if (response && response.status === 200) {
      return response.data;
    } else {
      console.log(response);
      showSnackbar(response.data.message, "error");

      return null;
    }
  } catch (error) {
    console.log("error", error);
    return null;
  }
}

async function createNit(payload, showSnackbar) {
  try {
    let apiEndpoint = `${config.baseUrl}${config.apiName.nitCreate}`;

    let response = await userService.post(apiEndpoint, payload);

    if (response && (response.status === 200 || response.status === 201)) {
      showSnackbar("NIT created successfully", "success");
      return response.data;
    } else {
      console.log(response);
      showSnackbar(response.data.message, "error");

      return null;
    }
  } catch (error) {
    console.log("error", error);
    return null;
  }
}

async function updateNit(id, payload, showSnackbar) {
  try {
    let apiEndpoint = `${config.baseUrl}${config.apiName.nitUpdate}?id=${id}`;

    let response = await userService.post(apiEndpoint, payload);

    if (response && response.status === 200) {
      showSnackbar("NIT updated successfully", "success");
      return response.data;
    } else {
      console.log(response);
      showSnackbar(response.data.message, "error");

      return null;
    }
  } catch (error) {
    console.log("error", error);
    return null;
  }
}

async function getAllContractTypes(showSnackbar) {
  try {
    const apiEndpoint = `${config.baseUrl}api/v1/all/type/of/contract`;

    const response = await userService.get(apiEndpoint);

    if (response && response.status === 200) {
      return response.data;
    } else {
      showSnackbar(response?.data?.message, "error");
      return [];
    }
  } catch (error) {
    console.log(error);
    return [];
  }
}

async function getAllWorkTypes(showSnackbar) {
  try {
    const apiEndpoint = `${config.baseUrl}api/v1/all/type/of/work`;

    const response = await userService.get(apiEndpoint);

    if (response && response.status === 200) {
      return response.data;
    } else {
      showSnackbar(response?.data?.message, "error");
      return [];
    }
  } catch (error) {
    console.log(error);
    return [];
  }
}

async function getNitById(nitId, showSnackbar) {
  try {
    let apiEndpoint = `${config.baseUrl}${config.apiName.getNitById}?id=${nitId}`;

    let response = await userService.get(apiEndpoint);

    if (response && response.status === 200) {
      return response.data;
    } else {
      console.log(response);
      showSnackbar(response.data.message, "error");

      return null;
    }
  } catch (error) {
    console.log("error", error);
    return null;
  }
}
async function getNitById2(nitId, showSnackbar) {
  try {
    let apiEndpoint = `${config.baseUrl}${config.apiName.getNitById2}?id=${nitId}`;

    let response = await userService.get(apiEndpoint);

    if (response && response.status === 200) {
      return response.data;
    } else {
      console.log(response);
      showSnackbar(response.data.message, "error");

      return null;
    }
  } catch (error) {
    console.log("error", error);
    return null;
  }
}
async function importNITs(formData, showSnackbar) {
  try {
    let apiEndpoint = `${config.baseUrl}${config.apiName.importNITs}`;

    let response = await userService.postWithFile(apiEndpoint, formData);

    if (response && (response.status === 200 || response.status === 201)) {
      return response.data;
    } else {
      console.log(response);
      showSnackbar(response.data.message, "error");
      return null;
    }
  } catch (error) {
    console.log("error", error);
    return null;
  }
}

async function createContractType(payload, showSnackbar) {
  try {
    const apiEndpoint = `${config.baseUrl}api/v1/create/type/of/contract`;
    const response = await userService.post(apiEndpoint, payload);

    if (response && response.status === 200) {
      return response.data;
    } else {
      showSnackbar(response?.data?.message, "error");
      return null;
    }
  } catch (error) {
    console.log(error);
    return null;
  }
}

async function createWorkType(payload, showSnackbar) {
  try {
    const apiEndpoint = `${config.baseUrl}api/v1/create/type/of/work`;
    const response = await userService.post(apiEndpoint, payload);

    if (response && response.status === 200) {
      return response.data;
    } else {
      showSnackbar(response?.data?.message, "error");
      return null;
    }
  } catch (error) {
    console.log(error);
    return null;
  }
}

async function deleteNit(id, showSnackbar) {
  try {
    let apiEndpoint = `${config.baseUrl}${config.apiName.deleteNit}?id=${id}`;

    let response = await userService.post(apiEndpoint);

    console.log("deletenitresp", response);

    if (response && response.status === 200) {
      showSnackbar(response?.data?.message, "success");
      return response.data;
    } else {
      showSnackbar(response?.data?.message, "error");
      return null;
    }
  } catch (error) {
    console.log("error", error);
    showSnackbar("Error deleting NIT", "error");
    return null;
  }
}
